import { useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";

import { SgdsMasthead } from "@govtechsg/sgds-masthead-react";

import Navbar from "../../Components/NavbarComponent";
import FooterComponent from "../../Components/FooterComponent";
import SideNavComponent from "../../Components/SideNavComponent";
import MastheadAnnouncement from '../../Components/MastheadAnnouncement'

import endpointsData from "../../json/sampleEndpts.json";
import AuthenticationComponent from "../../Components/AuthenticationComponent";

const AuthenticationServices = () => {
  const location = useLocation();
  const endpointreturn = (id) => {
    let endpt_elem = endpointsData;

    endpt_elem = endpt_elem.find((item) => item.page_section === id);

    const pythonCode = `import requests
      import os
            \nurl = "https://www.onemap.gov.sg${endpt_elem.sampleRequest}"
            \npayload = {
              "email": os.environ['ONEMAP_EMAIL'],
              "password": os.environ['ONEMAP_EMAIL_PASSWORD']
            }
            \nresponse = requests.request("POST", url, json=payload)
            \nprint(response.text)`;

    const jsCode = `const url = "https://www.onemap.gov.sg/${endpt_elem.sampleRequest}";

    // Prepare the data payload
    const data = JSON.stringify({
      email: process.env.ONEMAP_EMAIL,
      password: process.env.ONEMAP_EMAIL_PASSWORD
    });
    
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: data,
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(\`HTTP error! Status: \${response.status}\`);
        }
        return response.json();  // Parse response as JSON
      })
      .then(data => {
        console.log(data);  // Log the response data to the console
      })
      .catch(error => {
        console.error('Error:', error);  // Log any errors
      });
      `

    return {
      url: endpt_elem.endpoint,
      sampleRequest: endpt_elem.sampleRequest,
      sampleResponse: endpt_elem.sampleResponse,
      method: endpt_elem.method,
      pythonCode,
      jsCode,
    };
  };

  const { state } = location;
  const [activeKey, setActiveKey] = useState("");
  const clickButton = (key) => {
    activeKey === key ? setActiveKey("") : setActiveKey(key);
  };
  useEffect(() => {
    if (state === null) {
      clickButton("0");
    } else {
      clickButton(location.state.toString());
    }
  }, [state]);

  const [isCollapsed, setIsCollapsed] = useState(true);
  const handleCollapse = (e) => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      <Helmet>
        <title>Secure Access Token Generation for API Requests | OneMap API</title>
        <meta
          name="description"
          content="Use OneMap's Authentication API to securely generate an access token by authenticating users' email and password credentials. The access token is essential for accessing various API services, excluding search and map services. Learn how to send POST requests, securely store API keys and passwords, and prevent passing sensitive data in plain text. "
        />
      </Helmet>
      <MastheadAnnouncement/>
      <Navbar />
      <div className="row qx-0 mb-5 position-relative">
        <div className="col-1 d-md-none d-inline">
          <div
            className="btn btn-primary d-md-none position-fixed sideBarBtn"
            onClick={(e) => {
              handleCollapse();
              if (isCollapsed) {
                window.scrollTo(0, 0);
              }
            }}
          >
            Show Side Bar
          </div>
        </div>

        <div
          className={`qx-0 col-10 col-md-3 d-md-block  ${
            isCollapsed ? "collapse" : ""
          }`}
        >
          <SideNavComponent />
        </div>

        <div className="col-12 col-md-9 qx-0 px-3">
          <AuthenticationComponent
            clickButton={clickButton}
            endpointreturn={endpointreturn}
          />
        </div>
      </div>
      <FooterComponent />
    </>
  );
};
export default AuthenticationServices;
